const accessKeysDE = {
    "view": {
        "title": "Zugangsschlüssel",
        "form": {
            "label": {
                "accessKeyId": "Zugriffsschlüssel-ID",
                "secretAccessKey": "Geheimer Zugriffsschlüssel"
            },
            "button": {
                "hide": "Verbergen",
                "reveal": "Anzeigen"
            },
            "message": {
                "accessKeyIdCopied": "Zugriffsschlüssel-ID in die Zwischenablage kopiert!",
                "secretAccessKeyCopied": "Geheimer Zugriffsschlüssel in die Zwischenablage kopiert!"
            }
        },
        "uploadInstructions": {
            "title": "Anweisungen",
            "step1": {
                "title": "Schritt 1 - Upload-Tool herunterladen",
                "description": "Laden Sie das <1>Cyberduck</1>-Tool herunter."
            },
            "step2": {
                "title": "Schritt 2 - Kopie der Upload-Tabelle erstellen und Trigger-Datei speichern",
                "descriptionPoint1": "Kopieren Sie diese <1><strong>TABELLE</strong></1> in Ihr GOOGLE DRIVE.",
                "descriptionPoint2": "Speichern Sie diese <1><strong>TRIGGER-DATEI</strong></1> auf Ihrem Computer oder in der Cloud."
            },
            "step3": {
                "title": "Schritt 3 - Verbindung herstellen",
                "descriptionPoint1": "Öffnen Sie das Cyberduck-Tool.",
                "descriptionPoint2": "Klicken Sie in der unteren linken Ecke auf das + Symbol. (Neues Lesezeichen hinzufügen).",
                "descriptionPoint3": "Geben Sie folgende Anmeldedaten ein:",
                "descriptionPoint4": "Zugriffsschlüssel-ID: ",
                "descriptionPoint5": "Geheimer Zugriffsschlüssel: ",
                "descriptionPoint6": "Ihr S3-Ordner: ",
                "descriptionPoint7": "Ihr S3-Pfad: ",
                "descriptionPoint8": "Folgen Sie diesen Schritten:"
            },
            "step4": {
                "title": "Schritt 4 - Metadaten ausfüllen",
                "description": "Füllen Sie die Metadaten gemäß den Anweisungen in unserem Help Center aus."
            },
            "step5": {
                "title": "Schritt 5 - Dateien und Genres",
                "descriptionPoint1": "Laden Sie Ihre <1>metadata.csv</1>-Datei und alle Audio-<3>(.wav)</3> und <5>Bild (.jpg)</5>-Dateien hoch, <7> NICHT (.jpeg)</7>",
                "descriptionPoint2": "<strong>JPG-Dateien</strong> müssen <strong>3000x3000 px, max. Dateigröße 4MB</strong> sein",
                "descriptionPoint3": "Audiodateien müssen nur <strong>wav, 16 Bit, 44.1 kHz</strong> sein",
                "descriptionPoint4": "Stammdateinamen müssen ein Wort sein",
                "descriptionPoint5": "<strong>WICHTIG:</strong> Beachten Sie <2><strong>ML Dance Genres</strong></2> und die Zuordnung in den Stores wie Beatport."
            },
            "step6": {
                "title": "Schritt 6 - Trigger hochladen",
                "description": "Nachdem alle Dateien hochgeladen wurden, laden Sie bitte diese leere Trigger-Datei <1>„last.zzz“</1> hoch. Überwachen Sie Ihre E-Mails auf Benachrichtigungen."
            },
            "step7": {
                "title": "Hinweis - Testen Sie mit uns, bevor Sie hochladen",
                "description": "Zögern Sie nicht, unser Support-Team mit Fragen zu dieser Art der Veröffentlichungserstellung zu kontaktieren. Dies ist ein sehr einfacher Prozess, der auf robusteren Technologien wie AWS S3 basiert und nicht auf Browser-Technologien angewiesen ist. Es erfordert jedoch, dass Ihre Metadaten zu 100 % korrekt sind. Das Music Link-Team kann einige Veröffentlichungen mit Ihren Metadaten testen, um mögliche Probleme zu erkennen."
            }
        }
    }
};

export default accessKeysDE;